export const francePAEs = {
  comments: "Comentarios",
  rejection_reason: "Motivo del rechazo",
  invoiced_quantity: "Cantidad facturada",
  approved_quantity: "Cantidad aprobada",
  action_description: "Descripción de la acción",
  actual_vat_rate: "Tasa de IVA real",
  expected_vat_rate: "Tasa de IVA esperada",
  reason_description: "Descripción del motivo",
  reason_ext_code: "Código externo del motivo",
  fault_code: "Código de error",
  fault_message: "Mensaje de error",
  reason_key: "Clave del motivo",
  actual_value: "Valor real",
  expected_value: "Valor esperado",
  refusal_reason_ext_code: "Código externo del motivo de rechazo",
  refusal_reason_description: "Descripción del motivo de rechazo",
  value_date: "Fecha valor",
  payment_method: "Método de pago",
  payment_amount: "Importe del pago",
  payment_series: "Serie de pago",
  payment_code: "Código de pago",
  vat_base: "Base de IVA",
  vat_percent: "Porcentaje de IVA",
  xml_fault_path: "Ruta del error XML",
  vat_amount: "Importe de IVA",

  Deposited: "Depositada",
  Deposited_description:
    "Estado automático emitido por Invopop cuando el documento es depositado",

  IssuedByPlatform: "Emitida por la plataforma",
  IssuedByPlatform_description:
    "Factura emitida y transmitida por la plataforma del proveedor",

  ReceivedByPA: "Recibida por la Administración Pública",
  ReceivedByPA_description:
    "Factura recibida y reconocida por la Administración Pública",

  MadeAvailable: "Puesta a disposición",
  MadeAvailable_description:
    "Factura puesta a disposición para su procesamiento",

  TakenIntoAccount: "Tomada en cuenta",
  TakenIntoAccount_description:
    "La factura ha sido tomada en cuenta y está siendo procesada",

  Approved: "Aprobada",
  Approved_description: "Factura completamente aprobada y aceptada",

  PartiallyApproved: "Parcialmente aprobada",
  PartiallyApproved_description:
    "Factura aprobada parcialmente (algunos elementos aceptados y otros rechazados)",

  Disputed: "En disputa",
  Disputed_description: "La factura está en disputa y bajo revisión",

  Suspended: "Suspendida",
  Suspended_description:
    "El procesamiento de la factura está suspendido a la espera de una aclaración",

  Completed: "Completada",
  Completed_description: "El procesamiento de la factura ha finalizado",

  Refused: "Rechazada",
  Refused_description: "Factura rechazada por el comprador",

  PaymentAdviceSent: "Aviso de pago enviado",
  PaymentAdviceSent_description: "El aviso de pago ha sido transmitido",

  PaymentReceived: "Pago recibido",
  PaymentReceived_description: "El pago ha sido recibido y cobrado",

  RejectedByPlatform: "Rechazada por la plataforma",
  RejectedByPlatform_description:
    "Rechazada por la plataforma (error de validación o problema técnico)",

  "Deposited(200)": "Depositada (200)",
  "IssuedByPlatform(201)": "Emitida por la plataforma (201)",
  "ReceivedByPA(202)": "Recibida por la Administración Pública (202)",
  "MadeAvailable(203)": "Puesta a disposición (203)",
  "TakenIntoAccount(204)": "Tomada en cuenta (204)",
  "Approved(205)": "Aprobada (205)",
  "PartiallyApproved(206)": "Parcialmente aprobada (206)",
  "Disputed(207)": "En disputa (207)",
  "Suspended(208)": "Suspendida (208)",
  "Completed(209)": "Completada (209)",
  "Refused(210)": "Rechazada (210)",
  "PaymentAdviceSent(211)": "Aviso de pago enviado (211)",
  "PaymentReceived(212)": "Pago recibido (212)",
  "RejectedByPlatform(213)": "Rechazada por la plataforma (213)",
};
